import { confirmAlert as originalConfirmAlert } from '../external/react-confirm-alert';

interface IConfirmAlertOptions {

}

export function confirmAlert(options: IConfirmAlertOptions) {
    return new Promise((resolve, reject) => {
        originalConfirmAlert({
            closeOnClickOutside: false,
            ...options,
            closeOnEscape: false,
            customUIOptions: {
                resolve,
                reject
            }
        });
    });
}